import axios from "axios"
import { onAuthStateChanged, signInWithEmailAndPassword, signOut } from "firebase/auth"
import { doc, onSnapshot } from "firebase/firestore"
import { useEffect, useState } from "react"
import { auth, db } from "../config/firebase"

export default function useUser() {

    const [user, setUser] = useState(null)
    const [userLoading, setUserLoading] = useState(true)

    useEffect(() => {

        return onSnapshot(doc(db, `backup/xVvJ0cgMw4Y1xItNteiSF15fn5O2`), {
            next: data => {
                const userData = data.data()
                setUser(userData)
                setUserLoading(userData ? false : true)

            }
        })


    }, [])

    useEffect(() => {

        // getToken(msg, {
        //     vapidKey: "BKCVmjhpheit2x1MZlQxreqCsmkOcKpRin4CnTISJNlK_2OCe0pkA2Ir8IQH-tf76AvZb80NZWtd13zEH5Koeu8"
        // }).then(token => {
        //         setDoc(doc(db, `notifications/xVvJ0cgMw4Y1xItNteiSF15fn5O2`), {
        //             token
        //         })
            
        // }).catch(console.log)
        

        return onAuthStateChanged(auth, {
            next: async res => {

                if(res) {
                    
                    const token = await res.getIdToken(true)
                    axios.defaults.headers = {
                        "Authorization": `Bearer ${token}`
                    }
                     
                }
            }
        })

    }, [])

    async function signUserIn(password) {
        try {

            setUserLoading(true)
            await signInWithEmailAndPassword(
                auth, 
                'rasvictry@gmail.com', 
                password
            )

        } catch(err) {

        }
    }

    async function signUserOut() {
        await signOut(auth)
    }

    return { user, userLoading, signUserIn, signUserOut }
}